import Image from "next/image";
import dynamic from "next/dynamic";
const Form = dynamic(() => import("./Form"), {
  suspense: true,
});
import { Suspense, FC } from "react";

interface Props {
  headImage: any;
  title: string;
}

const Index: FC<Props> = ({ headImage, title }) => {
  return (
    <div className="flex flex-col lg:flex-row min-h-[400px] lg:min-h-[600px]">
      <div className="relative w-full lg:w-2/3 aspect-[16/9]">
        <Image
          src={`https://api.bungalowfinder.ca${headImage.url}`}
          alt={`Banner for ${title}`}
          layout="fill"
          objectFit="cover"
          priority
          sizes="(max-width: 1024px) 100vw, 66vw"
          onError={(e) => console.error('Image load error:', e)}
        />
      </div>

      <div className="w-full lg:w-1/3 flex flex-col justify-center p-6 lg:p-10 bg-gray-200">
        <h2 className="text-xl lg:text-2xl text-center mb-6">
          Register To Get Pricing for {title}
        </h2>
        <Suspense fallback={<p className="text-center">Loading...</p>}>
          <Form />
        </Suspense>
      </div>
    </div>
  );
};

export default Index;
